import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import { ModalHeader } from './common';
import { memo } from 'react';
import { useTranslation } from 'next-i18next';

export type TokenVerificationSuccessfulContentProps = {
  onClose: () => void;
};

export const TokenVerificationSuccessfulContent = memo(() => {
  const { t } = useTranslation('user-settings');
  const header = `${t('email_token_verified_successful')} 🥳`;
  return (
    <div className="flex flex-col items-center">
      <Image src={getAssetSrc('/utils-assets/success-check.svg')} width={64} height={64} alt={header} />
      <div className="mt-2 mb-10 ">
        <ModalHeader>{header}</ModalHeader>
      </div>
    </div>
  );
});
